module.exports = {
      id: "share-usage",
      viewBox: "0 0 13 13",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#share",
      toString: function () {
        return this.url;
      }
    }